import React from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import {SelectionMode, IntervalOptions, Interval} from '@models/index';
import {PurchaseStatus, PurchaseStatusOptions} from "@models/purchase";
import __i18n from "../../intl/__i18n";
import {DiscountCodePolicyCalculationTypeOptions, DiscountCodePolicyTypeOptions} from "../../models/discountCodePolicy";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SubscriptionsReportSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "query",
    label: __i18n("Title"),
    type: SearchInputType.TEXT,
    size: 8
    },
    {
      name: "type",
      label: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
      type: SearchInputType.SELECT,
      options: DiscountCodePolicyTypeOptions,
      size: 8
    },
    {
      name: __i18n("calculation_type"),
      label: __i18n("Calculation Type"),
      type: SearchInputType.SELECT,
      options: DiscountCodePolicyCalculationTypeOptions,
      size: 8
    },
  ];
  
  return (
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default SubscriptionsReportSearch;